import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { RecordedInterviewAssessmentDecision } from 'types';
import { Heading, Badge } from '@chakra-ui/react';
import { useTranslation } from "react-i18next";

export function getDescisionIconColorPair(decision: Exclude<RecordedInterviewAssessmentDecision, 'None'>) {
  switch (decision) {
    case RecordedInterviewAssessmentDecision.Pass:
      return { icon: regular('check'), colorScheme: 'green' };
    case RecordedInterviewAssessmentDecision.Fail:
      return { icon: regular('times'), colorScheme: 'red' };
    case RecordedInterviewAssessmentDecision.Resit:
    default:
      return { icon: regular('arrow-rotate-right'), colorScheme: 'orange' };
  }
}

interface IDescisionSegment {
  descision?: RecordedInterviewAssessmentDecision;
  labelSize?: string;
}
export default function RecordedInterviewDescisionSegment({
  descision = RecordedInterviewAssessmentDecision.None,
  labelSize = 'md',
}: IDescisionSegment) {
    const { t } = useTranslation('common');
  if (descision === RecordedInterviewAssessmentDecision.None) {
    return null;
  }

  const { icon, colorScheme } = getDescisionIconColorPair(descision);

  return (
    <>
      <Heading as="h3" fontSize={labelSize} fontWeight="medium" mb="2">
        {t('common:decisionSuggested')}
                    </Heading>

      <Badge size="sm" colorScheme={colorScheme} variant="outline" mb="4">
        <FontAwesomeIcon icon={icon} />
        {descision}
      </Badge>
    </>
  );
}
